import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription} from "../../user/user-subscription";
import {DbActiveModal} from "../../modules/modal/modal-ref";
import {Store} from "@ngrx/store";
import * as fromStore from '../../store';
import {DbResponse} from "../../shared/interceptors/db-response";
import {UserService} from "../../user/user.service";
import {getUserLocalStorage, getUserLocalStorageLoaded} from "../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {TypeUtils} from "../../shared/utils/type-utils";
import {SizePipe} from "../../shared/pipes/size.pipe";
import {CountPipe} from "../../shared/pipes/count.pipe";

@Component({
    selector: 'db-websites-empty-dedicated-hosting',
    templateUrl: './websites-empty-dedicated-hosting.component.html',
    styleUrls: ['./websites-empty-dedicated-hosting.component.scss'],
    standalone: false
})
export class WebsitesEmptyDedicatedHostingComponent implements OnInit {

  @Input() userSubscription: UserSubscription;
  @Input() fromDialog?: boolean = false;
  @Output() readonly resized? = new EventEmitter<[number, number]>();
  public planIncludes: Array<string> = [];
  private _userLocalStorage: any;

  constructor(
    private _activeModal: DbActiveModal,
    private _store: Store<fromStore.DbStoreState>,
    private _userService: UserService,
    private size: SizePipe,
    private count: CountPipe,
  ) { }

  ngOnInit() {
    if (this.userSubscription.dedicatedInfo) {
      this.planIncludes = [
        `${this.userSubscription.dedicatedInfo.cpuCore}-Core CPU`,
        `${this.userSubscription.dedicatedInfo.phpWorkers} PHP Workers`,
        `${this.size.transform(parseInt(this.userSubscription.dedicatedInfo.ram, 10) * 1024 * 1024)} RAM`
      ]
    }
    this.planIncludes.push(`${this.size.transform(this.userSubscription.plan.services.hosting.hosting_storage.parameter_value * 1024 * 1024)} SSD Storage`, `${this.count.transform(this.userSubscription.plan.services.hosting.hosting_visits.parameter_value)} Monthly Visitors`)
    if (!!this.fromDialog) {
      this._activeModal.resize(562,  700);
    }
    this._getLocalStorage();
  }

  private _getLocalStorage(): void {
    this._store.select(getUserLocalStorageLoaded)
      .pipe(
        first(loaded => loaded),
        switchMap(() => this._store.select(getUserLocalStorage)),
        first(),
      )
      .subscribe(userLocalStorage => {
        this._userLocalStorage = userLocalStorage;
        if((this._userLocalStorage && TypeUtils.isUndefined(this._userLocalStorage.dedicatedHostingTicketSent)) || !!this.fromDialog){
          this._createZendeskTicket()
        }
      });
  }

  public openChat(): void {
    this._activeModal.close();
    window['Smooch']?.open();
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

  public close(): void {
    this._activeModal.close();
  }

  private _createZendeskTicket(): void {
    const data = {
      comment: 'Successfully purchased Dedicated hosting plan',
      subject: 'Dedicated Plan Flow',
    };
    this._userService.createZendeskTicket(data)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response) => {
        if (response.success) {
          this._dedicatedHostingZendeskTicketSent();
        }
      });
  }

  private _dedicatedHostingZendeskTicketSent(): void {
    const updatedUserLocalStorage = {...this._userLocalStorage, dedicatedHostingTicketSent: true};
    this._userService.setToLocal(updatedUserLocalStorage)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
      });
  }

}
